// extracted by mini-css-extract-plugin
export default {"thumbnail":"filethumb_thumbnail__1ow6B"};